import React, { useEffect } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { UseGlobellogin } from './component/Logincontaxt.jsx/Logincontex';
import Scrolltop from './Scrolltop';
import { MdOutlineMailOutline } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import { FaCartShopping } from "react-icons/fa6";
import { Usecartcontaxt } from './component/cartcontaxt/cart_contaxt';
import { BASE_URL } from './Config/Config';
import Toast from './ToastMessage/ToastMessage';
import Whatsapp_icon from './component/WhatsappIcon/Whatsapp_icon';
import { UseGlobelcourse } from './component/allcoursecontaxt/ALLCoursecontaxt';
import Loader from './Loader/Loader';


function Header() {
  const { handleLogout, isLoggedIn, successfully, errormessage, setIsSignin, userName, user_img, userEmail , isLoggingOut } = UseGlobellogin();
  const { databasecartdata } = Usecartcontaxt();
  const {dispatch} = UseGlobelcourse();
  const [show, setShow] = useState(false);
  const [categorydata, setCategoryData] = useState([]);
  const [isSticky, setIsSticky] = useState(false);
  const [togle , settogle] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [openGroupIndex, setOpenGroupIndex] = useState(null);
  const [email, setmail] = useState();
  const [isDropdownOpen, setisDropdownOpen] = useState(false);
  const location = useLocation();

  const Navigate = useNavigate();
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    const email = localStorage.getItem("userEmail");
    setmail(email);
  }, [])
  const handleProfile = () => {
    Navigate('/profail')
  };
  const toggleDropdown = () => {
    setisDropdownOpen((prev) => !prev);
  }
  const api = `${BASE_URL}/coursecategory/`;
  const getCategoryData = async (url) => {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      } else {
        const resData = await response.json();
        setCategoryData(resData.data);
      }
    } catch (error) {
      console.error('Failed to fetch data', error);
    }
  };
  useEffect(() => {
    if (categorydata.length === 0) {
      getCategoryData(api);
    }
  }, [categorydata]);
  console.log(categorydata);



  const groupedCategories = categorydata.reduce((acc, category) => {
    const segmentId = category.coursesugment.id;
    const segmentName = category.coursesugment.name;

    if (!acc[segmentId]) {
      acc[segmentId] = {
        name: segmentName,
        items: []
      };
    }
    acc[segmentId].items.push(category);
    return acc;
  }, {});




  const togglemenubtn = () => {
    settogle(!togle);
  }


  const handleDropdownToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle "Our Courses"
    setOpenGroupIndex(null); // Reset group dropdown when closing "Our Courses"
  };

  const handleGroupToggle = (index) => {
    setOpenGroupIndex(openGroupIndex === index ? null : index); // Toggle each group
  };

  useEffect(() => {
    const handleScroll = (event) => {
      // Set the sticky state based on the scroll position
      if (event.target.closest(".dropdown-menu") || event.target.closest(".btn-group") || event.target.closest(".th-menu-area") || event.target.closest(".th-mobile-menu")) {
        return; // Do nothing if the link is clicked
      }
      setisDropdownOpen(false);
      settogle(false);

    };
    window.addEventListener('mousedown', handleScroll);
    return () => {
      window.removeEventListener('mousedown', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const targetElement = document.getElementById('target-section');
      const scrollPosition = window.scrollY;

      if (targetElement) {
        const targetOffset = targetElement.offsetTop;

        if (scrollPosition >= targetOffset) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      } else {
        // If target section not found (like on detail pages), disable sticky by default
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Call once on route change
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location]);


  const handleCategoryClick = (category_name)=>{
dispatch({
    type: 'UPDATE_FILTER_VALUE',
    payload: { name: 'categoryname', value:category_name },
  });
  }
  return (

    <>
      <Whatsapp_icon />
      <Scrolltop />
      {/* {successfully && (

        <div className="alert alert-success success-msg" role="alert"  style={{
           position:"fixed",
           top:'50px',
           right:'20px',
           zIndex:'1050',
           animation:"fadeOut 3s ease forwards",
           padding:"10px",
           width:"12rem",
           textAlign:"center",
           color:"green"
        }}>
          {successfully}
        </div>

           )} */}
      <Toast successfully={successfully} errorMessage={errormessage} />




      <div>
        {/*==============================
     Preloader
  ==============================*/}
        {/* <div className="preloader ">
          <button className="th-btn style3 preloaderCls">Cancel Preloader </button>
          <div className="preloader-inner">
            <span className="loader" />
          </div>
        </div> */}
        {/*==============================
    Sidemenu
============================== */}

        {/* <div className="sidemenu-wrapper d-none d-lg-block ">
          <div className="sidemenu-content">
            <button className="closeButton sideMenuCls"><i className="far fa-times" /></button>
            <div className="widget woocommerce widget_shopping_cart">
              <h3 className="widget_title">Shopping cart</h3>
              <div className="widget_shopping_cart_content">
                <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                  <li className="woocommerce-mini-cart-item mini_cart_item">
                    <a href="#" className="remove remove_from_cart_button"><i className="far fa-times" /></a>
                    <a href="#"><img src="assets/img/product/product_thumb_1_1.jpg" alt="Cart Image" />Plastic Book Bags</a>
                    <span className="quantity">1 ×
                      <span className="woocommerce-Price-amount amount">
                        <span className="woocommerce-Price-currencySymbol">$</span>940.00</span>
                    </span>
                  </li>
                  <li className="woocommerce-mini-cart-item mini_cart_item">
                    <a href="#" className="remove remove_from_cart_button"><i className="far fa-times" /></a>
                    <a href="#"><img src="assets/img/product/product_thumb_1_2.jpg" alt="Cart Image" />The Genie Mind</a>
                    <span className="quantity">1 ×
                      <span className="woocommerce-Price-amount amount">
                        <span className="woocommerce-Price-currencySymbol">$</span>899.00</span>
                    </span>
                  </li>
                  <li className="woocommerce-mini-cart-item mini_cart_item">
                    <a href="#" className="remove remove_from_cart_button"><i className="far fa-times" /></a>
                    <a href="#"><img src="assets/img/product/product_thumb_1_3.jpg" alt="Cart Image" />The Energy Book</a>
                    <span className="quantity">1 ×
                      <span className="woocommerce-Price-amount amount">
                        <span className="woocommerce-Price-currencySymbol">$</span>756.00</span>
                    </span>
                  </li>
                  <li className="woocommerce-mini-cart-item mini_cart_item">
                    <a href="#" className="remove remove_from_cart_button"><i className="far fa-times" /></a>
                    <a href="#"><img src="assets/img/product/product_thumb_1_4.jpg" alt="Cart Image" />Pencil Bag</a>
                    <span className="quantity">1 ×
                      <span className="woocommerce-Price-amount amount">
                        <span className="woocommerce-Price-currencySymbol">$</span>723.00</span>
                    </span>
                  </li>
                  <li className="woocommerce-mini-cart-item mini_cart_item">
                    <a href="#" className="remove remove_from_cart_button"><i className="far fa-times" /></a>
                    <a href="#"><img src="assets/img/product/product_thumb_1_5.jpg" alt="Cart Image" />Sharpner</a>
                    <span className="quantity">1 ×
                      <span className="woocommerce-Price-amount amount">
                        <span className="woocommerce-Price-currencySymbol">$</span>1080.00</span>
                    </span>
                  </li>
                </ul>
                <p className="woocommerce-mini-cart__total total">
                  <strong>Subtotal:</strong>
                  <span className="woocommerce-Price-amount amount">
                    <span className="woocommerce-Price-currencySymbol">$</span>4398.00</span>
                </p>
                <p className="woocommerce-mini-cart__buttons buttons">
                  <a href="cart.html" className="th-btn wc-forward">View cart</a>
                  <a href="checkout.html" className="th-btn checkout wc-forward">Checkout</a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="popup-search-box d-none d-lg-block">
          <button className="searchClose"><i className="fal fa-times" /></button>
          <form action="#">
            <input type="text" placeholder="What are you looking for?" />
            <button type="submit"><i className="fal fa-search" /></button>
          </form>
        </div> */}
        {/*==============================
    Mobile Menu
  ============================== */}
  {
    isLoggingOut && (<> 
      <Loader/>
    </>)
  }
        <div className={togle ? 'th-menu-wrapper th-body-visible' : 'th-menu-wrapper'}>
          <div className="th-menu-area text-center">
            <button className="th-menu-toggle" onClick={togglemenubtn}><i className="fal fa-times" /></button>
            <div className="mobile-logo">
              <NavLink to="/"><img src="assets/img/AA_LOgo_Black.png" alt="Edura" /></NavLink>
            </div>

            <div className="th-mobile-menu">
              <ul>
                <li>
                  <NavLink to="/" onClick={togglemenubtn}>Home</NavLink>
                </li>

                <li className="menu-item-has-children">
                  <a  onClick={() => handleDropdownToggle(0)}>
                    Our Courses
                  </a>
                  <ul className="sub-menu" style={{ display: openIndex === 0 ? 'block' : 'none' }}>
                    {Object.keys(groupedCategories).map((sugment, index) => {
                      const group = groupedCategories[sugment];
                      return (
                        <li
                          className="menu-item-has-children"
                          key={sugment}
                        >
                          <NavLink
                            
                            onClick={(e) => {
                              e.preventDefault();
                              handleGroupToggle(index);
                            }}
                          >
                            {group.name}
                          </NavLink>

                          <ul className="sub-menu" style={{ display: openGroupIndex === index ? 'block' : 'none' }}>
                            {group.items.map((category) => (
                              <li key={category.category_id} onClick={() => { 
                                togglemenubtn();
                                handleCategoryClick(category.category_name);
                                 }}>
                                <NavLink to={`/course`} >
                                  {category.category_name}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>
                </li>
                <li>
                  <NavLink to="/about" onClick={togglemenubtn}>About us</NavLink>
                </li>
                <li>
                  <NavLink to="/blog"onClick={togglemenubtn}>Blog</NavLink>
                </li>
                <li>
                  <NavLink to="/contact"onClick={togglemenubtn}>Contact us</NavLink>
                </li>

                <li className="menu-item-has-children">
                  <NavLink >Resources</NavLink>
                  <ul className="sub-menu">
                    {/* <li><NavLink to="/Placmant">Placement</NavLink></li> */}

                    <li><NavLink to="/itservice" onClick={togglemenubtn}>IT Services</NavLink></li>
                    <li><NavLink to="/ourinstructer"onClick={togglemenubtn}>Become An instructor</NavLink></li>

                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/*==============================
	Header Area
==============================*/}

   {/* <header className="th-header header-layout1 onepage-nav">
          <div className="header-top">
            <div className="container">
              <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
                <div className="col-auto d-none d-lg-block">
                  <div className="header-links">
                    <ul>
                      <li><i className="far fa-phone" /><NavLink to="tel:+91 9460548809">+91 9460548809</NavLink></li>
                      <li className="d-none d-xl-inline-block"><i className="far fa-envelope" /><NavLink to="mailto:contact@auratechacademy.com">contact@auratechacademy.com</NavLink></li>
                      <li><i className="far fa-clock" />Mon - Sat: 8:00 - 20:00</li>
                    </ul>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="header-links header-right">
                    <ul>

                      <li style={{ display: "flex", gap: "2rem", alignItems: "center", justifyContent: "space-between" }}>
                        
                        {isLoggedIn ? (
                          <div className="btn-group">

                            <button
                              type="button"
                              className="btn btn-primary dropdown-toggle"
                              data-toggle="dropdown"
                              onClick={toggleDropdown}
                              aria-haspopup="true"
                              aria-expanded={isDropdownOpen ? "true" : "false"}
                            >
                              {console.log("userimg", user_img)}
                              {
                                user_img ? (
                                  <img
                                    src={user_img}
                                    alt="Profile"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                      marginRight: "8px"
                                    }}
                                  />
                                ) : (
                                  <i className="far fa-user" style={{ marginRight: "8px" }} />
                                )
                              }
                              <span style={{ fontWeight: "600" }}>{userName}</span>
                            </button>


                            {isDropdownOpen && (
                              <div className="dropdown-menu show" >
                                <NavLink to="/" className="dropdown-item" style={{ fontWeight: "500", cursor: 'pointer', background: "#fff" }} ><MdOutlineMailOutline style={{ fontSize: "1.2rem", marginRight: "1rem" }} />{userEmail}</NavLink>

                                <NavLink to="/profail" className="dropdown-item" onClick={handleProfile} style={{ fontWeight: "500", cursor: 'pointer', background: "#fff" }}><FaUserCircle style={{ fontSize: "1.2rem", marginRight: "1rem" }} />profile</NavLink>

                                <NavLink to="/" className="dropdown-item" onClick={handleLogout} style={{ fontWeight: "500", cursor: 'pointer', background: "#fff" }}> <IoIosLogOut style={{ fontSize: "1.2rem", marginRight: "1rem" }} /> Log Out</NavLink>
                              </div>
                            )}

                            <NavLink to="/cartpage"> <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: "pointer" }}>
                              <FaCartShopping style={{ fontSize: '2rem', color: "#fff" }} />
                              <span
                                className='badge bg-primary'
                                style={{
                                  fontSize: '.6rem',
                                  display: 'inline-block',
                                  padding: '0.3rem 0.5rem',
                                  borderRadius: '50%',
                                }}
                              >
                                {databasecartdata?.length}
                              </span>
                            </h3></NavLink>


                          </div>

                        ) : (

                         

                          <li style={{ cursor: 'pointer' }}>
                            <i className="far fa-user" />
                            <NavLink to="/login" className="login-btn text-decoration-none" onClick={() => setIsSignin(false)} >Login</NavLink> /
                            <NavLink to="/login" className="register-btn text-decoration-none" onClick={() => setIsSignin(true)}>Register</NavLink>
                          </li>

                        )}

                        <div className="header-social">
                          <span className="social-title">Follow Us:</span>
                          <NavLink to="https://www.instagram.com/auratechindia/" target="_blank" ><i class="fa-brands fa-instagram" /></NavLink>

                          <NavLink to="https://www.linkedin.com/company/auratechacademy/posts/?feedView=all" target="_blank"><i className="fab fa-linkedin-in" /></NavLink>

                          <NavLink to="https://www.youtube.com/@AURATECHACADEMY" target="_blank"><i className="fab fa-youtube" /></NavLink>
                        </div>


                      </li>

                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div className={`sticky-wrapper ${isSticky ? 'sticky' : ''}`}>
            <div className="menu-area">
              <div className="container">
                <div className="row align-items-center justify-content-between">
                  <div className="col-auto">
                    <div className="header-logo">
                      <NavLink to='/'><img src="/assets/img/AA_LOgo_Black.png" alt="AuraetchAcademy" style={{ width: 250 }} /></NavLink>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="row">
                      <div className="col-auto">
                        <nav className="main-menu d-none d-lg-inline-block">
                          <ul>
                            <li>
                              <NavLink to="/">Home</NavLink>
                            </li>

                            <li className="menu-item-has-children">
                              <NavLink to="/">Our Courses</NavLink>
                              <ul className="sub-menu">
                                {Object.keys(groupedCategories).map((segmentId) => {
                                  const group = groupedCategories[segmentId];
                                  return (
                                    <li className="menu-item-has-children" key={segmentId}>
                                      <NavLink to="">{group.name}</NavLink>
                                      <ul className="sub-menu">
                                        {group.items.map((category) => (
                                          <li key={category.id}>
                                            <NavLink to="/course#target-section">
                                              {category.category_name}
                                            </NavLink>
                                          </li>
                                        ))}
                                      </ul>
                                    </li>
                                  );
                                })}
                              </ul>
                            </li>


                            <li><NavLink to="/about">About Us</NavLink></li>
                            <li><NavLink to="/blog">Blog</NavLink></li>
                            <li><NavLink to="/contact">Contact Us</NavLink></li>

                            <li className="menu-item-has-children"><NavLink to="/">Resources</NavLink>
                              <ul className="sub-menu">
                                <li>
                                  <a href="https://auratechindia.com/" target="_blank" rel="noopener noreferrer">
                                    IT Services
                                  </a>
                                </li>
                                <li><NavLink to="/ourinstructer">Become An instructor </NavLink></li>
                              </ul>
                            </li>
                          </ul>
                        </nav>
                        <button type="button" className="th-menu-toggle d-block d-lg-none" onClick={togglemenubtn}><i className="far fa-bars" /></button>
                      </div>
                      <div className="col-auto d-none d-xl-block">
                        <div className="header-button">
                         
                          <NavLink to="/contact" className="th-btn ml-25">Contact Us <i className="fas fa-arrow-right ms-1" /></NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header> */}

        <header className="th-header header-layout1 onepage-nav">

    {/* <div className="header-top py-2">
  <div className="container">
    <div className="row align-items-center justify-content-between gy-2">
     
      <div className="col-lg-auto d-none d-lg-block">
        <div className="header-links">
          <ul className="d-flex flex-wrap gap-3 align-items-center mb-0 list-unstyled">
            <li>
              <i className="far fa-phone me-1" />
              <a href="tel:+919460548809">+91 9460548809</a>
            </li>

            <li className="d-none d-xxl-inline-block">
              <i className="far fa-envelope me-1" />
              <a href="mailto:contact@auratechacademy.com">contact@auratechacademy.com</a>
            </li>

            <li>
              <i className="far fa-clock me-1" />
              Mon - Sat: 8:00 - 20:00
            </li>
          </ul>
        </div>
      </div>

      
      <div className="col-12 col-lg-auto">
        <div className="header-links header-right text-center text-lg-end">
          <ul className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3 mb-0 list-unstyled">

            <li className="d-flex align-items-center gap-3">
              {isLoggedIn ? (
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle d-flex align-items-center gap-2"
                    onClick={toggleDropdown}
                  >
                    {user_img ? (
                      <img
                        src={user_img}
                        alt="Profile"
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          objectFit: "cover"
                        }}
                      />
                    ) : (
                      <i className="far fa-user" />
                    )}
                    <span>{userName}</span>
                  </button>

                  {isDropdownOpen && (
                    <div className="dropdown-menu show">
                      <NavLink to="/" className="dropdown-item">
                        <MdOutlineMailOutline className="me-2" /> {userEmail}
                      </NavLink>
                      <NavLink to="/profail" className="dropdown-item" onClick={handleProfile}>
                        <FaUserCircle className="me-2" /> Profile
                      </NavLink>
                      <NavLink to="/" className="dropdown-item" onClick={handleLogout}>
                        <IoIosLogOut className="me-2" /> Logout
                      </NavLink>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <i className="far fa-user me-1" />
                  <NavLink to="/login" className="text-decoration-none me-1" onClick={() => setIsSignin(false)}>
                    Login
                  </NavLink>
                  /
                  <NavLink to="/login" className="text-decoration-none ms-1" onClick={() => setIsSignin(true)}>
                    Register
                  </NavLink>
                </div>
              )}
            </li>

           
            {isLoggedIn && (
              <li>
                <NavLink to="/cartpage">
                  <div className="position-relative d-flex align-items-center">
                    <FaCartShopping style={{ fontSize: '1.6rem', color: "#fff" }} />
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary"
                      style={{ fontSize: '.65rem' }}
                    >
                      {databasecartdata?.length}
                    </span>
                  </div>
                </NavLink>
              </li>
            )}

            
            <li className="d-flex align-items-center gap-2">
              <span className="social-title me-2">Follow Us:</span>
              <NavLink to="https://www.instagram.com/auratechindia/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram" />
              </NavLink>
              <NavLink to="https://www.linkedin.com/company/auratechacademy/posts/?feedView=all" target="_blank" rel="noreferrer">
                <i className="fab fa-linkedin-in" />
              </NavLink>
              <NavLink to="https://www.youtube.com/@AURATECHACADEMY" target="_blank" rel="noreferrer">
                <i className="fab fa-youtube" />
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
        </div> */}

    <div className="header-top py-2">
  <div className="container">
    <div className="row align-items-center justify-content-between gy-2">
     
      <div className="col-lg-auto d-none d-lg-block">
        <div className="header-links">
          <ul className="d-flex flex-wrap gap-3 align-items-center mb-0 list-unstyled">
            <li>
              <i className="far fa-phone me-1" />
              <a href="tel:+919460548809">+91 9460548809</a>
            </li>

            <li className="d-none d-xxl-inline-block">
              <i className="far fa-envelope me-1" />
              <a href="mailto:contact@auratechacademy.com">contact@auratechacademy.com</a>
            </li>

            <li>
              <i className="far fa-clock me-1" />
              Mon - Sat: 8:00 - 20:00
            </li>
          </ul>
        </div>
      </div>

      
      <div className="col-12 col-lg-auto">
        <div className="header-links header-right text-center text-lg-end ">
          <ul className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-end gap-3 mb-0 list-unstyled flex-row text-nowrap w-100 ul-hide">

            <li className="d-flex align-items-center gap-2">
              {isLoggedIn ? (
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle d-flex align-items-center gap-2"
                    onClick={toggleDropdown}
                  >
                    {user_img ? (
                      <img
                        src={user_img}
                        alt="Profile"
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          objectFit: "cover"
                        }}
                      />
                    ) : (
                      <i className="far fa-user" />
                    )}
                    <span>{userName}</span>
                  </button>

                  {isDropdownOpen && (
                    <div className="dropdown-menu show">
                      <NavLink to="/" className="dropdown-item">
                        <MdOutlineMailOutline className="me-2" /> {userEmail}
                      </NavLink>
                      <NavLink to="/profail" className="dropdown-item" onClick={handleProfile}>
                        <FaUserCircle className="me-2" /> Profile
                      </NavLink>
                      <NavLink to="/" className="dropdown-item" onClick={handleLogout}>
                        <IoIosLogOut className="me-2" /> Logout
                      </NavLink>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <i className="far fa-user me-1" />
                  <NavLink to="/login" className="text-decoration-none me-1" onClick={() => setIsSignin(false)}>
                    Login
                  </NavLink>
                  /
                  <NavLink to="/login" className="text-decoration-none ms-1" onClick={() => setIsSignin(true)}>
                    Register
                  </NavLink>
                </div>
              )}
            </li>

           
            {isLoggedIn && (
              <li>
                <NavLink to="/cartpage">
                  <div className="position-relative d-flex align-items-center">
                    <FaCartShopping style={{ fontSize: '1.6rem', color: "#fff" }} />
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary"
                      style={{ fontSize: '.65rem' }}
                    >
                      {databasecartdata?.length}
                    </span>
                  </div>
                </NavLink>
              </li>
            )}

            <li className="hide-mobile d-none d-lg-flex align-items-center gap-2 flex-wrap">
              <span className="social-title">Follow Us:</span>
              <NavLink to="https://www.instagram.com/auratechindia/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram" />
              </NavLink>
              <NavLink to="https://www.linkedin.com/company/auratechacademy/posts/?feedView=all" target="_blank" rel="noreferrer">
                <i className="fab fa-linkedin-in" />
              </NavLink>
              <NavLink to="https://www.youtube.com/@AURATECHACADEMY" target="_blank" rel="noreferrer">
                <i className="fab fa-youtube" />
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
        </div>


          <div className={`sticky-wrapper ${isSticky ? 'sticky' : ''}`}>
            <div className="menu-area">
              <div className="container">
                <div className="row align-items-center justify-content-between">

                  <div className="col-auto">
                    <div className="header-logo">
                      <NavLink to='/'><img src="/assets/img/AA_LOgo_Black.png" alt="AuraetchAcademy" style={{ width: 250 }} /></NavLink>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="row">
                      <div className="col-auto">
                        <nav className="main-menu d-none d-lg-inline-block">
                          <ul>
                            <li>
                              <NavLink to="/">Home</NavLink>
                            </li>

                            <li className="menu-item-has-children">
                              <NavLink to="/">Our Courses</NavLink>
                              <ul className="sub-menu">
                                {Object.keys(groupedCategories).map((segmentId) => {
                                  const group = groupedCategories[segmentId];
                                  return (
                                    <li className="menu-item-has-children" key={segmentId}>
                                      <NavLink to="">{group.name}</NavLink>
                                      <ul className="sub-menu">
                                        {group.items.map((category) => (
                                          <li key={category.id}
                                           onClick={() => handleCategoryClick(category.category_name)}
                                          >
                                            <NavLink to="/course#target-section">
                                              {category.category_name}
                                            </NavLink>
                                          </li>
                                        ))}
                                      </ul>
                                    </li>
                                  );
                                })}
                              </ul>
                            </li>


                            <li><NavLink to="/about">About Us</NavLink></li>
                            <li><NavLink to="/blog">Blog</NavLink></li>
                            <li><NavLink to="/contact">Contact Us</NavLink></li>

                            <li className="menu-item-has-children"><NavLink to="/">Resources</NavLink>
                              <ul className="sub-menu">
                                {/* <li><NavLink to="/Placmant">Placement </NavLink></li> */}
                                <li>
                                  <a href="https://auratechindia.com/" target="_blank" rel="noopener noreferrer">
                                    IT Services
                                  </a>
                                </li>
                                <li><NavLink to="/ourinstructer">Become An instructor </NavLink></li>
                              </ul>
                            </li>
                          </ul>
                        </nav>

                        <button type="button" className="th-menu-toggle d-block d-lg-none" onClick={togglemenubtn}><i className="far fa-bars" /></button>
                        
                      </div>
                      <div className="col-auto d-none d-xl-block">
                        <div className="header-button">
                          {/* <button type="button" className="icon-btn searchBoxToggler"><i className="far fa-search" /></button> */}
                          {/* <a href="wishlist.html" class="icon-btn">
                                      <i class="far fa-heart"></i>
                                      <span class="badge">3</span>
                                  </a>
                                  <button type="button" class="icon-btn sideMenuToggler">
                                      <i class="far fa-shopping-cart"></i>
                                      <span class="badge">5</span>
                                  </button> */}
                          <NavLink to="/contact" className="th-btn ml-25">Contact Us <i className="fas fa-arrow-right ms-1" /></NavLink>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </header>

      </div>


      {/* <Modal
  show={show}
  onHide={handleClose}
  size="xl"
  backdrop="static"
  centered
  dialogClassName="custom-modal"
>
  <Modal.Header closeButton style={{ padding: "10px" }} />
  <Modal.Body>
    {isSignin ? (
      <Signin setIsSignin={setIsSignin} toggleForm={toggleForm} />
    ) : (
      <Login handleClose={handleClose} setIsSignin={setIsSignin} />
    )}
  </Modal.Body>
  <Modal.Footer className="d-flex flex-wrap justify-content-between gap-2">
    <Button className="th-btn style3" onClick={toggleForm}>
      {isSignin ? "Switch to Log In" : "Switch to Sign Up"}{" "}
      <i className="fas fa-arrow-right ms-2" />
    </Button>
    <Button className="th-btn style3 bg-danger border-danger" onClick={handleClose}>
      Close <i className="fas fa-arrow-right ms-2" />
    </Button>
  </Modal.Footer>
</Modal> */}



    </>
  )
}

export default Header
